// extracted by mini-css-extract-plugin
module.exports = {"openModalBtn":"ChangeClinic_openModalBtn__az9tI","footer":"ChangeClinic_footer__1oPJp"};